import * as types from './types';

const INITIAL_STATE = {
    checkoutData: {},
    liveChecks: {},
    pricingHistory: {},
};

function _setTripCheckoutData(state, action) {
    const {
        lcId,
    } = action.meta;

    return {
        ...state,
        checkoutData: {
            ...state.checkoutData,
            [lcId]: action.payload,
        },
    };
}

function _setTripLiveCheck(state, action) {
    const {
        lcId,
    } = action.meta;
    const tripLiveCheck = action.payload;
    const {
        trip_id: tripId,
        pricing,
        seats,
        selected_fare: selectedFare,
    } = tripLiveCheck.tripData;

    return {
        ...state,
        liveChecks: {
            ...state.liveChecks,
            [lcId]: tripLiveCheck,
        },
        pricingHistory: {
            ...state.pricingHistory,
            [tripId]: [
                { pricing, seats, selectedFare },
                (state.pricingHistory[tripId] || [])[0],
            ],
        },
    };
}

function _removeTripLiveChecks(state, action) {
    const {
        lcId,
    } = action.meta;

    const {
        [lcId]: lcToRemove,
        ...updatedLiveChecks
    } = state.liveChecks;

    if (!lcToRemove) {
        return {
            ...state,
        };
    }

    const { trip_id: tripId } = lcToRemove.tripData;
    const {
        [tripId]: _pricingToRemove,
        ...updatedPricingHistory
    } = state.pricingHistory;

    return {
        ...state,
        liveChecks: updatedLiveChecks,
        pricingHistory: updatedPricingHistory,
    };
}

const handlers = {
    [types.SET_TRIP_CHECKOUT_DATA]: _setTripCheckoutData,
    [types.SET_TRIP_LIVE_CHECK]: _setTripLiveCheck,
    [types.REMOVE_TRIP_LIVECHECKS]: _removeTripLiveChecks,
};

function reducer(state = INITIAL_STATE, action) {
    if (handlers.hasOwnProperty(action.type)) {
        const handler = handlers[action.type];

        return handler(state, action);
    }

    return state;
}

export {
    INITIAL_STATE,
};

export default reducer;
